// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)


export const Accordion = new function() {
  let accordions;
  let headers;
  let toggles;

  this.init = () => {
    if (!document.querySelector('.ss-accordion')) return;
    this.accordions = gsap.utils.toArray('.ss-accordion');
    this.headers = gsap.utils.toArray('.ss-accordion__header');
    this.toggles = this.accordions.map(this.createToggle);

    this.headers.forEach(header => {
      header.addEventListener("click", () => this.toggle(header));
    });
  },

  this.toggle = (clickedHeader) => {
    this.toggles.forEach(toggle => toggle(clickedHeader));
    ScrollTrigger.refresh();
  },

  this.createToggle = (element) => {
    const header = element.querySelector(".ss-accordion__header");
    const body = element.querySelector(".ss-accordion__body");
    const content = element.querySelector(".ss-accordion__cnt");
    const icon = element.querySelector(".ss-icon");

    gsap.set(body, { height: "auto" });

    const tl = gsap.timeline({ paused: true });

    tl.to(body, {
      height: 0,
      duration: 0.3,
      ease: "power1.inOut"
    })
      .set(body, { height: "auto" })
      .from(body, {
        height: 0,
        duration: 0.3,
        ease: "power1.inOut"
      })
      .fromTo(content, {
        opacity: 0
      }, {
        opacity: 1,
        duration: 0.25
      })
      .to(icon, {
        rotation: "180deg",
        duration: 0.35
      });

    const toggle = tl.reverse();

    return function (clickedHeader) {
      if (clickedHeader === header) {
        toggle.reversed(!toggle.reversed());
      } else {
        toggle.reverse();
      }
    }
  }
};